export function friendlyError(error: unknown): string {
  const code = typeof error === "object" && error !== null && "code" in error
    ? String(error.code)
    : "";

  const messages: Record<string, string> = {
    "auth/email-already-in-use": "An account already exists for that email.",
    "auth/invalid-credential": "That email and password combination did not work.",
    "auth/invalid-email": "Enter a valid email address.",
    "auth/network-request-failed": "Google sign-in could not connect. Check your connection and try again.",
    "auth/operation-not-allowed": "Google sign-in is temporarily unavailable.",
    "auth/popup-blocked": "Your browser blocked the sign-in window. Please allow it and try again.",
    "auth/popup-closed-by-user": "The sign-in window was closed before finishing.",
    "auth/requires-recent-login": "For your security, sign in again before deleting your account.",
    "auth/too-many-requests": "Too many verification emails were requested. Wait a few minutes and try again.",
    "auth/unauthorized-domain": "Google sign-in is not authorized on this website.",
    "auth/weak-password": "Use a password with at least six characters.",
    "auth/web-storage-unsupported": "Your browser is blocking the storage needed to sign in.",
    "auth/multi-factor-auth-required": "Enter the code from your authenticator app.",
    "auth/invalid-verification-code": "That authenticator code is invalid or expired.",
    "auth/invalid-multi-factor-session": "That authenticator request expired. Sign in again.",
    "permission-denied": "Your account does not have permission to do that.",
    "functions/already-exists": "That username, passkey, or connection already exists.",
    "functions/deadline-exceeded": "That request expired. Please try again.",
    "functions/failed-precondition": "That security option is not available for this account.",
    "functions/invalid-argument": "Check the information you entered and try again.",
    "functions/not-found": "That item could not be found or is no longer available.",
    "functions/permission-denied": "That action is not available for this account.",
    "functions/resource-exhausted": "You have reached the current limit. Remove an active item and try again.",
    "functions/unauthenticated": "Sign in again to continue.",
    "storage/unauthorized": "That private photo could not be stored for this account.",
    "storage/retry-limit-exceeded": "The photo upload timed out. Check your connection and try again.",
    "storage/quota-exceeded": "Photo storage is temporarily unavailable.",
    "ERROR_CEREMONY_CANCELLED": "The passkey prompt was canceled.",
    "ERROR_CEREMONY_TIMED_OUT": "The passkey prompt timed out. Please try again.",
  };

  return messages[code] ?? (code
    ? `Something went wrong (${code}). Please try again.`
    : "Something went wrong. Please try again.");
}
